module.exports = __webpack_public_path__ + "img/symbol_10.fb145d18.png";